import type { ExperimentConfig } from '../@types'

const config: ExperimentConfig[] = [
	{
		'activity-female-tai-chi-walking-pr': {
			// /result_complete?safe&mock-data&utm_source=FB&country=US&area=activity-female-tai-chi-walking-pr&exp=web_upsell_pace_segments~1
			upsell: {
				experiment: {
					'upsell-tai-chi-walking-f': () =>
						import(/* webpackChunkName: "upsell" */ '@/modules/Upsell/instances/experiments/web_upsell_pace_segments'),
				},
			},
		},
		'activity-female-tai-chi-walking-v2': {
			// /result_complete?safe&mock-data&utm_source=FB&country=US&area=activity-female-tai-chi-walking-v2&exp=web_upsell_pace_segments~1
			upsell: {
				experiment: {
					'upsell-tai-chi-walking-f': () =>
						import(/* webpackChunkName: "upsell" */ '@/modules/Upsell/instances/experiments/web_upsell_pace_segments'),
				},
			},
		},
		'activity-female-tai-chi-walking-v2-al': {
			// /result_complete?safe&mock-data&utm_source=FB&country=US&area=activity-female-tai-chi-walking-v2-al&exp=web_upsell_pace_segments~1
			upsell: {
				experiment: {
					'upsell-tai-chi-walking-f': () =>
						import(/* webpackChunkName: "upsell" */ '@/modules/Upsell/instances/experiments/web_upsell_pace_segments'),
				},
			},
		},
		female: {
			// /result_complete?safe&mock-data&utm_source=FB&country=US&area=female&exp=web_upsell_pace_segments~1
			upsell: {
				experiment: {
					'upsell-f': () =>
						import(/* webpackChunkName: "upsell" */ '@/modules/Upsell/instances/experiments/web_upsell_pace_segments'),
				},
			},
		},
	},
]

export default config
